<template>
  <div class="post type-post hentry" id="post-2">
    <h2>Apie save</h2>
    <div class="entry">
      <p>
        Esu gimęs 1950 m. lapkričio 18 d. gražiausioje Šakių rajono vietoje –
        Sudarge.
      </p>
      <p>
        1978 m. Vilniaus valstybiniame universitete įgijau teisininko
        kvalifikaciją. Dirbau Šakių r. žemės ūkio valdyboje vyresniuoju
        juriskonsultu, Šakių r. aplinkos apsaugos inspektoriumi, 18 metų buvau
        teismo tarėju. Lietuvai atgavus nepriklausomybę tapau pirmuoju Šakių
        rajono Tarybos pirmininku, vėliau – pirmuoju Šakių rajono meru. Buvau
        renkamas Lietuvos savivaldybių Asociacijos viceprezidentu.
      </p>
      <p>
        Gyvenime teko būti statybininku, jūrininku, dailininku. Dalyvavau
        Lietuvos persitvarkymo Sąjūdyje, buvau Lietuvos Krikščionių Demokratų
        partijos nariu ir dvi kadencijas LKDP Šakių r. skyriaus pirmininku.
        Partijai keičiant generalinę liniją ir pavadinimą, savo įsitikinimų
        nepakeičiau – likau nepartiniu. Lietuvoje kuriantis naujai Krikščionių
        partijai, 2010 m.rudenį subūriau bendraminčius ir esu Šakių skyriaus
        pirmininku.
      </p>
      <p>
        Laisvalaikį mėgstu praleisti gamtoje: ilgus metus dirbau
        gamtosaugininku, buvau medžiotoju. Dabar pamėgau spiningavimą. Mėgstu
        keliauti, sportuoti. Moku naudotis įvairiais ginklais, netgi sportiniu
        lanku. Sukaupiau daug gyvenimo patirties, leidžiančios gerai orientuotis
        įvairiausiose gyvenimo situacijose bei sudėtingiausiuose santykiuose
        tarp įvairių asmenų.
      </p>
      <p>
        Advokato praktika užsiimu nuo 1999 metų. Turiu savo kontorą Šakiuose
        Bažnyčios g. 15. Įvairaus teisinio darbo praktika – 37 metai. Atstovauju
        žmonių ir įmonių interesus civilinėse, administracinėse ir
        baudžiamosiose bylose visų lygių teismuose bei kitose institucijose.
      </p>
      <p>
        Nesivaikydamas didelių įkainių, imuosi įvairių teisinių darbų.
        Mėgstamiausios sritys: sutartys, prievolių, turto nuosavybės, valdymo ir
        disponavimo reikalai, šeimos, globos, paveldėjimo ir kitų civilinės
        teisės šakų problemos. Garantuoju kliento problemos supratimą, jo
        informacijos konfidencialumą, kokybišką, profesionalią ir operatyvią
        teisinę pagalbą, pagarbą klientui. Profesiniais klausimais bendrauju
        lietuvių, rusų ir lenkų kalbomis. Pirminę informaciją galiu suteikti
        vokiškai ir angliškai.
      </p>
      <p>
        Esu vedęs. Žmona Zita notarė – Šakių r. antrojo notarų biuro savininkė.
        Vaikai Daiva ir Edvardas dirba elektronikos ir kompiuterių
        specialistais.
      </p>
    </div>
  </div>
</template>
